<template>
  <v-card v-if="project" id="project-view">
    <div class="video-responsive">
      <v-img :aspect-ratio="16 / 9" :src="project.thumbnail_large">
        <v-overlay absolute :value="!frame_loaded">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-img>
      <iframe
        id="project-iframe"
        @load="frameLoaded"
        v-show="frame_loaded"
        :src="videoIframe"
        frameborder="0"
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>

    <v-container fluid>
      <v-row>
        <v-col cols="12" lg="12">
          <h1 class="text-h3">{{ project.title }}</h1>
        </v-col>
      </v-row>
      <v-divider class="mb-2"></v-divider>
      <v-row>
        <v-col cols="12" lg="12">
          <div
            class="my-2 caption"
            v-html="$store.state.app.affiliate_notification"
          ></div>
          <div class v-html="project.description"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-chip
            :to="`/?search=${tag}`"
            class="mr-1 mb-1"
            small
            label
            v-for="(tag, t) in project.tags.split(',')"
            :key="t"
            >{{ tag }}</v-chip
          >
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>

    <v-card-actions class="grey lighten-3">
      <h3>Support</h3>
      <v-spacer></v-spacer>
      <v-chip
        @click="sponsor_project(option)"
        class="ma-2 clicky"
        color="green"
        text-color="white"
        v-for="(option, i) in $store.getters['app/supportOptions']"
        :key="i"
      >
        <v-avatar left class="white">
          <v-icon small color="green darken-2">fa-dollar-sign</v-icon>
        </v-avatar>
        {{ option }}
      </v-chip>
    </v-card-actions>
    <v-card-actions class="secondary white--text" v-if="project.additional"
      >Around the web</v-card-actions
    >
    <template v-if="project.additional">
      <template v-for="(item, i) in project.additional.body">
        <project-section
          v-if="item.slice_type == 'section'"
          :key="i"
          :title="item.primary.title"
          :image="item.primary.image.url"
          :description="item.primary.description"
          :link="item.primary.link.url"
        ></project-section>

        <project-table
          v-if="item.slice_type == 'table'"
          :key="i"
          :title="item.primary.title"
          :columns="[
            item.primary.column_1,
            item.primary.column_2,
            item.primary.column_3,
            item.primary.column_4,
            item.primary.column_5,
          ]"
          :items="item.items"
        ></project-table>
      </template>
    </template>
  </v-card>
</template>
<script>
import section from "./section";
import table from "./table";

export default {
  name: "",
  props: ["project"],
  data: () => ({
    frame_loaded: false,
  }),
  components: {
    projectSection: section,
    projectTable: table,
  },
  mounted() {
    setTimeout(this.initEvents, 3000);
  },
  methods: {
    onClickDescription(ev) {
      console.log("onClickDescription", ev);
    },
    initEvents() {
      document.querySelectorAll("#project-view a").forEach((i) => {
        i.addEventListener("click", this.onLinkClick);
      });
      document.querySelectorAll("#project-view button").forEach((i) => {
        i.addEventListener("click", this.onLinkClick);
      });
    },
    onLinkClick(ev) {
      console.log("Link clicked");
      return window.gtag_report_conversion(ev.target.href);
    },
    frameLoaded() {
      setTimeout(
        function () {
          this.frame_loaded = true;
        }.bind(this),
        0
      );
    },
    sponsor_project(option) {
      try {
        document
          .querySelector("#project-iframe")
          .contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
      } catch (ex) {
        console.error(ex);
      }

      this.$eventBus.$emit("support", {
        project_id: this.project.id,
        account_id: this.project.account_id,
        option: option,
      });
    },
  },
  watch: {
    "this.project": function () {
      this.frame_loaded = false;
    },
  },
  updated() {},
  computed: {
    videoIframe() {
      return (
        this.$helpers.iframeFromUrl(this.project.url) +
        "?autoplay=0&enablejsapi=1&rel=0"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
.text-h3 {
  display: block;
  font-size: 1.1em;
  font-weight: bold;
}
</style>
